import React from 'react'
import { Container, Disclaimer, SupportLink, Title } from './styles'
import { message } from '~/services'
import {
  SUPPORT_EMAIL_ADDRESS,
  SUPPORT_EMAIL_ADDRESS_LINK,
  SUPPORT_PHONE_NUMBER,
  SUPPORT_WHATSAPP_PHONE_LINK,
  SUPPORT_WHATSAPP_PHONE_NUMBER
} from '~/constants'

export const Footer = (): JSX.Element => {
  return (
    <Container>
      <Title>{message('feedback.support_question')}</Title>

      <Disclaimer>{message('feedback.support_disclaimer')}</Disclaimer>

      <Disclaimer>Telefone: {SUPPORT_PHONE_NUMBER}</Disclaimer>

      <Disclaimer>
        Whatsapp:{' '}
        <SupportLink href={SUPPORT_WHATSAPP_PHONE_LINK} target="_blank">
          {SUPPORT_WHATSAPP_PHONE_NUMBER}
        </SupportLink>
      </Disclaimer>

      <Disclaimer>
        E-mail:{' '}
        <SupportLink href={SUPPORT_EMAIL_ADDRESS_LINK} target="_blank">
          {SUPPORT_EMAIL_ADDRESS}
        </SupportLink>
      </Disclaimer>
    </Container>
  )
}
